/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, centerAbsolutely, imageTypes, animations, mediaQuery } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SPLASH STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
  uniquecontent: {
    // curtain backgrounds that animated open on scroll
    '& .curtains': {
      extend: centerAbsolutely,
      width: '100%',
      height: '100%',
      zIndex: '2',
      '& .curtain': {
        background: '#111',
        opacity: '.9',
        width: '50.1%', // slightly larger to avoid media query issues with width when adjusting via font size percentages
        height: '100%',
        position: 'absolute',
        top: '0',
        '&.left': { left: '0' },
        '&.right': { right: '0' }
      },
      '&.optIn .curtain': {
        opacity: '0'
      }
    },
    // large partner logo in center of screen
    '& .partner': {
      extend: [imageTypes.logo],
      backgroundSize: 'contain',
      width: pxToEm(237),
      height: pxToEm(100),
      position: 'absolute',
      top: '48%',
      left: '50%',
      marginTop: pxToEm(-50),
      marginLeft: pxToEm(-118.5),
      '&:hover': {
        extend: animations.imageHover
      },
      '&.clickable-false': {
        pointerEvents: 'none',
        cursor: 'default'
      }
    },
    // insticator logo near bottom
    '& .company': {
      textAlign: 'center',
      position: 'absolute',
      bottom: pxToEm(20),
      left: '50%',
      marginLeft: pxToEm(-70),
      '& .text': {
        color: color.white,
        fontSize: pxToEm(12),
        marginBottom: pxToEm(12)
      },
      '& .image': {
        extend: imageTypes.logo,
        width: pxToEm(140),
        height: pxToEm(13),
        backgroundImage: `url(${url.image.app}/logo-insticator-light-opt.png)`,
        '&:hover': {
          extend: animations.imageHover
        }
      },
      '& .progressbar': {
        width: pxToEm(140),
        marginTop: pxToEm(10),
        marginBottom: '0'
      }
    },
    // !!!!!!! INVIEW (user has scrolled and the embed is in their view, perform and animation and move to next content) !!!!!!!! //
    '&.inview-true': {
      pointerEvents: 'none',
      '& .partner': {
        backfaceVisibility: 'visible',
        animationName: 'flipOutX',
        animationDelay: '.5s',
        animationDuration: '1.3s',
        animationFillMode: 'forwards'
      },
      '& .company': {
        '& .text': {
          backfaceVisibility: 'visible',
          animationName: 'fadeOut',
          animationDelay: '.5s',
          animationDuration: '1.3s',
          animationFillMode: 'forwards'
        },
        '& .image': {
          backfaceVisibility: 'visible',
          animationName: 'fadeOut',
          animationDelay: '.5s',
          animationDuration: '1.3s',
          animationFillMode: 'forwards'
        },
        '& .progressbar': {
          backfaceVisibility: 'visible',
          animationName: 'fadeOut',
          animationDelay: '.5s',
          animationDuration: '1.3s',
          animationFillMode: 'forwards'
        }
      },
      '& .curtains': {
        '& .curtain': {
          animationDelay: '1.4s',
          animationDuration: '.7s',
          animationFillMode: 'forwards',
          '&.left': { animationName: 'slideOutLeft' },
          '&.right': { animationName: 'slideOutRight' }
        }
      }
    },
    '&.cookieChecked-true': {
      '& .progressbar': {
        backfaceVisibility: 'visible',
        animationName: 'fadeOut',
        animationDelay: '.5s',
        animationDuration: '1.3s',
        animationFillMode: 'forwards'
      }
    }
  },
  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thin]: {
    uniquecontent: { fontSize: '80%' }
  }
};
